import { isDuotoneFamily } from 'app/releases.js'

export const IconsMixins = {
  data() {
    return {}
  },

  computed: {
    isDuotoneIcon() {
      // If this is an iconUpload, the selectedStyle will not be 'duotone',
      // but if it has duotone pathData, it should still be treated as a duotone icon.
      // family: classic style: duotone check covers version 5
      return isDuotoneFamily(this.styling?.family) || !!this.icon?.pathSecondary || (this.styling?.family === 'classic' && this.styling?.style === 'duotone')
    }
  }
}
